import apiHeader from '@/helpers/apiHeader';

const glAccountService = {
  list(page, params) {
    return apiHeader.get('gl-accounts?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('gl-accounts/' + id);
  },
};

export default glAccountService;
